import { useQuery } from 'react-query';
import { useCurrentUser } from '@qualio/ui-components';
import approversApi from '../api/approvers.api';

export const useEventFormReviewers = (formId: number) => {
  const { companyId } = useCurrentUser();

  return useQuery(
    ['reviewersList', companyId, formId],
    () => approversApi.getApprovers(companyId, formId, 'reviewers'),
    { staleTime: 10000 },
  );
};
